// type
import type { Components, Theme } from "@mui/material";

export const MuiSelect: Components<Theme>["MuiSelect"] = {
  defaultProps: {
    variant: "outlined",
    MenuProps: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
      PaperProps: {
        sx: {
          borderRadius: 3,
          mt: 1,
        },
      },
    },
  },
  styleOverrides: {
    outlined: ({ theme }) => ({
      borderRadius: 12,
    }),
  },
};
